import { useState, useEffect } from "react"
import axios from 'axios';
import { BaseUrl } from "../App"; 
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


const Referral = () => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [referralStatus, setReferralStatus] = useState(false)
  const [referralValue, setReferralValue] = useState("")
  const [referCodeValue, setReferCodeValue] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [isUpdating, setIsUpdating] = useState(false)
  const [successMessage, setSuccessMessage] = useState("")
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchSettings()
  }, [])
  
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);

  const fetchSettings = async () => {
    setLoading(true);
      try {
          const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
              action: "get_all_settings",
              api_key: "1" // Replace with your actual API key
          }, {
              headers: {
                  "Content-Type": "application/json"
              }
          });
  
          if (response.data.status === "true" && response.data.statuscode === 200) {
              const settings = response.data.response;
              const referralStatus = settings.find((s) => s.option_name === "ct_referral_status")?.option_value === "Y";
              const referralValue = settings.find((s) => s.option_name === "ct_refs_value")?.option_value || "";
              const referCodeValue = settings.find((s) => s.option_name === "ct_referral_value")?.option_value || "";
  
              setIsExpanded(referralStatus);
              setReferralStatus(referralStatus);
              setReferralValue(referralValue);
              setReferCodeValue(referCodeValue);
          } else {
              console.error("Failed to fetch settings:", response.data.response);
          }
      } catch (error) {
          console.error("Error fetching settings:", error);
      }
      finally {
        setLoading(false);
      }
  };
  
  const updateSetting = async (optionName, optionValue) => {
    setLoading(true);
      try {
          console.log(`Attempting to update ${optionName} with value: ${optionValue}`);
          const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
              action: "update_setting",
              api_key: "1", // Replace with your actual API key
              option_name: optionName,
              option_value: optionValue
          }, {
              headers: {
                  "Content-Type": "application/json"
              }
          });
  
          if (response.data.status === "true" && response.data.statuscode === 200) {
            setSuccessMessage("Update Refferral Code Successfully!")
              console.log(`Successfully updated ${optionName}`);
              return true;
          } else {
              console.error(`Failed to update ${optionName}:`, response.data.response);
              return false;
          }
      } catch (error) {
          console.error(`Error updating ${optionName}:`, error);
          return false;
      }
      finally {
        setLoading(false);
      }
  };
  

  const handleSave = async () => {
    const updates = [
      { name: "ct_refs_value", value: referralValue },
      { name: "ct_referral_value", value: referCodeValue },
    ]

    let successCount = 0
    for (const update of updates) {
      const success = await updateSetting(update.name, update.value)
      if (success) successCount++
    }

    if (successCount === updates.length) {
      alert("All settings updated successfully!")
      await fetchSettings()
    } else {
      alert(
        `Only ${successCount} out of ${updates.length} settings were updated successfully. Please check the console for more details.`,
      )
    }
  }

  const toggle = async () => {
    if (isUpdating) return
    setIsUpdating(true)
    const newStatus = !referralStatus
    setIsExpanded(newStatus)
    setReferralStatus(newStatus)

    const success = await updateSetting("ct_referral_status", newStatus ? "Y" : "N")
    if (!success) {
      // If the update fails, revert the UI change
      setIsExpanded(!newStatus)
      setReferralStatus(!newStatus)
      setErrorMessage("Failed to update referral status. Please try again.")
    } else {
      setErrorMessage("")
    }
    setIsUpdating(false)
  }

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6">
        <h2 className="text-gray-700 font-bold text-2xl mb-4 sm:mb-0">Referral Details</h2>
        <div className="flex items-center space-x-4">
          <label htmlFor="referralcode" className="block text-gray-700 font-medium">
            Referral Code Status
          </label>
          <button
            onClick={() => void toggle()}
            disabled={isUpdating}
            className={`relative w-12 h-6 rounded-full transition-all duration-500 flex items-center justify-center text-sm ${
              referralStatus ? "bg-green-500 text-white" : "bg-gray-300 text-gray-600"
            } ${isUpdating ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            <div
              className={`w-6 h-6 bg-white rounded-full absolute transition-all ${
                referralStatus ? "right-0.5" : "left-0.5"
              }`}
            />
            {isUpdating && (
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              </div>
            )}
          </button>
        </div>
      </div>

      <div
        className={`overflow-hidden transition-all duration-1000 ease-in-out`}
        style={{
          height: isExpanded ? "auto" : "0",
          opacity: isExpanded ? "1" : "0",
          paddingTop: isExpanded ? "10px" : "0",
          paddingBottom: isExpanded ? "10px" : "0",
        }}
      >
        {isExpanded && (
          <div className="space-y-6">
            <div>
              <label htmlFor="referralValue" className="block text-gray-700 font-medium mb-2">
                Referral Code Value:
              </label>
              <input
                id="referralValue"
                type="text"
                value={referralValue}
                onChange={(e) => setReferralValue(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label htmlFor="referCodeValue" className="block text-gray-700 font-medium mb-2">
                Refer Code Value
              </label>
              <input
                id="referCodeValue"
                type="text"
                value={referCodeValue}
                onChange={(e) => setReferCodeValue(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <button
                onClick={handleSave}
                className="w-full sm:w-auto px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
              >
                Save
              </button>
            </div>
          </div>
        )}
      </div>
      {errorMessage && (
        <div className="mt-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">{errorMessage}</div>
      )}
    </div>
      
  </div>
  )
}

export default Referral
